"use client";
import Image from "next/image";
import { Heading } from "@/components/ui/typography";

export default function ComplianceCTATwo({ heading = "Offshore Status Is Not Automatic It's Applied For" }: { heading?: string } = {}) {
  return (
    <section className="w-full flex justify-center md:py-[60px] py-[30px] px-4 min-[1340px]:px-0">
      
      <div className="w-full max-w-[1200px] flex flex-col lg:flex-row gap-10 lg:gap-[32px] items-center">

        {/* LEFT CONTENT */}
         <div className="flex-1 flex justify-center items-center h-full">
          <Image
            src="/tax-optimization/compliance-cta-two.webp"
            alt="Compliance"
            width={700}
            height={700}
            className="w-full h-[420px] sm:h-[580px] lg:h-[634px] object-cover rounded-[16px]"
          />
        </div>
          {/* RIGHT IMAGE */}
        <div className="flex-1 flex flex-col gap-8">

          {/* HEADING */}
          <div className="flex flex-col gap-6">
            <Heading as="h2" variant="section">
              {heading}
            </Heading>

            <p className="text-white/70 text-[15px] sm:text-[16px] leading-[24px] font-medium">
              Many founders misunderstand this. Opening a Hong Kong company alone does not create offshore tax treatment. Your company must:
            </p>
          </div>

          {/* CHECKLIST */}
          <div className="flex flex-col gap-4">

            {[
              "Operate outside Hong Kong",
              "Document operations correctly",
              "Apply through the IRD",
              "Maintain compliance annually",
            ].map((item, i) => (
              <div key={i} className="flex gap-3 items-start">
                <div className="pt-[4px]">
                  <Image
                    src={`/list-check.svg`}
                    alt="tick"
                    width={19}
                    height={19}
                  />
                </div>
                <p className="text-white/70 text-[16px] leading-[150%] flex-1">
                  {item}
                </p>
              </div>
            ))}

          </div>

          {/* IMPORTANT BOX */}
          <div className="bg-[#0f1218] border border-white/10 rounded-[12px] p-6 shadow-md">
            <p className="text-[14px] leading-[150%]">

              <span className="text-white/70 font-medium">
                MuteTaxes prepares and supports this process. This is the difference between opening a company and building a tax structure.
              </span>
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}